export interface UseListDisplayStateOptions {
    isLoading: boolean
    isFetching: boolean
    isFetchingNextPage?: boolean
    isTyping: boolean
    itemCount: number
    filteredCount?: number
    hasSearchTerm: boolean
}

export interface UseListDisplayStateReturn {
    showLoadingState: boolean
    showEmptyState: boolean
    showNoResults: boolean
}

export default function useListDisplayState(options: UseListDisplayStateOptions): UseListDisplayStateReturn {
    const {
        isLoading,
        isFetching,
        isFetchingNextPage = false,
        isTyping,
        itemCount,
        filteredCount,
        hasSearchTerm,
    } = options

    const safeItemCount = Math.max(0, itemCount)
    const safeFilteredCount = Math.max(0, filteredCount ?? safeItemCount)
    const isListFetching = isFetching && !isFetchingNextPage

    const showLoadingState = isLoading || (isListFetching && safeItemCount === 0)
    const showEmptyState = !isLoading && !isFetching && !isTyping && safeItemCount === 0 && !hasSearchTerm
    const showNoResults = !isLoading && !isFetching && !isTyping && safeFilteredCount === 0 && hasSearchTerm

    return {
        showLoadingState,
        showEmptyState,
        showNoResults,
    }
}
